import "./Shop.module.css";
import MainIndustrialHeader from "@/reusable_sections/Header";
import ShopTitle from "./sections/ShopTitle";
import ShopContent from "./sections/ShopContent";
import IndustrialFooter from "@/reusable_sections/Footer";
export default function ShopPage() {
  return <div>
      <MainIndustrialHeader />
      <ShopTitle />
      <ShopContent />
      <IndustrialFooter />
    </div>;
}